export default {
  type: Object.freeze({
    CLINIC: 'clinic', DENTAL_LABORATORY: 'dental-laboratory', CLINIC_DENTAL_LABORATORY: 'clinic-dental-laboratory',
    CLINIC_LABEL: 'Клиника', DENTAL_LABORATORY_LABEL: 'Зуботехническая лаборатория',
    CLINIC_DENTAL_LABORATORY_LABEL: 'Клиника/Зуботехническая лаборатория'
  }),
  ateType: Object.freeze({ A1: 'a1', ASTERISK: 'asterisk', A1_LABEL: 'A1', ASTERISK_LABEL: 'Asterisk' }),
  subscription: { category: Object.freeze({ ACCOUNTS: 'accounts', ACCOUNTS_LABEL: 'Счета' }) },
  smsBalance: { category: Object.freeze({ ACCOUNTS: 'accounts', ACCOUNTS_LABEL: 'Счета' }) },
}
